function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPeopleRegisterAccountRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.008 28.016c.02-1.552.08-6.274 1.406-7.602.87-.87 2.437-1.955 4.412-3.055a2.964 2.964 0 001.496-2.143 2.987 2.987 0 00-.78-2.519C9.557 11.646 9 10.91 9 8c0-1.845 1.047-4 3.998-4C15.952 4 17 6.155 17 8c0 2.91-.558 3.646-1.543 4.697a2.99 2.99 0 00.717 4.662c1.975 1.1 3.542 2.185 4.412 3.055 1.327 1.328 1.386 6.05 1.417 7.586l-17.995.016zm13.138-12.404a.99.99 0 01-.23-1.548C18.306 12.583 19 11.333 19 8c0-3-2-6-6.002-6C9 2 7 5 7 8c0 3.333.694 4.583 2.083 6.064a.99.99 0 01-.23 1.548C7.516 16.356 5.321 17.679 4 19c-1.676 1.676-1.948 5.456-1.992 8.991A1.985 1.985 0 003.996 30h18.007a1.985 1.985 0 001.988-2.009c-.044-3.535-.316-7.315-1.99-8.991-1.323-1.321-3.518-2.644-4.855-3.388zM26 6V2h-2v4h-4v2h4v4h2V8h4V6h-4z",
    fill: props.color
  }));
}

export default SvgIconPeopleRegisterAccountRexOutline;